import React from 'react';
import { useTranslation } from 'react-i18next'
import './unordered-list.css'

export interface UnorderedListProps extends React.HTMLProps<HTMLDivElement> { //make sure to handle 
  /**
   * header is used at the top of the list
   */
  header?: string,
  /**
   * text takes in any number of strings to use as the bullet points in your list
   */
  text: string[],
};

export function UnorderedList(props: UnorderedListProps) {

  const { text, header, ...htmlProps } = props
  const { t } = useTranslation()

  return (
    <div {...htmlProps}>
      {header && <p className='unordered-list-cmp-header'>{header}</p>}
      <ul className='custom-list'>
        {text.map(item => (
          <li className='pokeball-list' key={item}>{item}</li>
        ))}
      </ul>
    </div>
  );
}